import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID, COLLECTION } from '@/plugins/sdk/fields'
import BGroup from '@/plugins/sdk/resources/Dictionary/BGroup'
import Portfolio from '@/plugins/sdk/resources/Dictionary/Portfolio'

export default class extends Resource {
  static name = 'dictionary_businessbranch'
  static label = 'long_name'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      long_name: new STRING(),
      bgroup: new COLLECTION(BGroup),
      portfolio: new COLLECTION(Portfolio)
    }
  }
}
